module.exports = __webpack_public_path__ + "19b13feafb394ceef0f6eb89ece27908.pdf";